import {Link} from "react-router-dom";

import styles from "./active-link.module.scss";

const ActiveLink = ({children, link, target = "_self"}) => {
    return <Link target={target} className={styles.link} to={link}>{children}</Link>
}

export default ActiveLink;